import { useState } from 'react';
import { Tab, Tabs } from '@blueprintjs/core';

import { Box, Flex } from '../../../shared/components';
import { type Account, type CustomRole } from '../../model';

import { CustomRolesPanel } from './CustomRolesPanel';
import { TeamsPanel } from './TeamsPanel';

type RolesAndTeamsTabProps = Readonly<{
  account: Account;
  customRoles: { [accountId: string]: CustomRole };
}>;

export const RolesAndTeamsTab = ({ account, customRoles }: RolesAndTeamsTabProps) => {
  const [selectedTab, setSelectedTab] = useState<string>('teams');

  const customRolesList = Object.values(customRoles);

  return (
    <Flex>
      <Box width={1} p={2}>
        <Tabs
          id="rolesAndTeamsTabs"
          selectedTabId={selectedTab}
          onChange={(newTabId) => setSelectedTab(newTabId as string)}
          animate={false}
          renderActiveTabPanelOnly
        >
          <Tab id="teams" title="Teams" panel={<TeamsPanel key={account._id} customRoles={customRoles} account={account} />} />
          <Tab id="customRoles" title="Custom Roles" panel={<CustomRolesPanel customRoles={customRolesList} />} />
        </Tabs>
      </Box>
    </Flex>
  );
};
